import React from 'react';

const Sharing = () => {
  return (
    <svg width='56' height='56' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M28.4815 27.3396C31.7198 27.3396 34.3449 24.7144 34.3449 21.4762C34.3449 18.2379 31.7198 15.6128 28.4815 15.6128C25.2433 15.6128 22.6182 18.2379 22.6182 21.4762C22.6182 24.7144 25.2433 27.3396 28.4815 27.3396Z'
        stroke='#2481C4'
      />
      <path
        d='M28.4801 31.1672C33.9403 31.1672 38.5141 34.9665 39.7004 40.0658H17.2598C18.4461 34.9665 23.0199 31.1672 28.4801 31.1672Z'
        stroke='#2481C4'
      />
      <path
        d='M42.8087 27.34C45.2659 27.34 47.258 25.348 47.258 22.8907C47.258 20.4334 45.2659 18.4414 42.8087 18.4414C40.3514 18.4414 38.3594 20.4334 38.3594 22.8907C38.3594 25.348 40.3514 27.34 42.8087 27.34Z'
        stroke='#2481C4'
      />
      <path
        d='M35.1973 33.1424C36.9735 31.1908 39.5667 29.9607 42.4548 29.9607C47.2257 29.9607 51.1918 33.3172 51.9999 37.7382H38.9196'
        stroke='#2481C4'
      />
      <path
        d='M13.8173 27.34C11.36 27.34 9.36802 25.348 9.36802 22.8907C9.36802 20.4334 11.36 18.4414 13.8173 18.4414C16.2746 18.4414 18.2666 20.4334 18.2666 22.8907C18.2666 25.348 16.2746 27.34 13.8173 27.34Z'
        stroke='#2481C4'
      />
      <path
        d='M21.4286 33.1424C19.6524 31.1908 17.0592 29.9607 14.1711 29.9607C9.40015 29.9607 5.4341 33.3172 4.62598 37.7382H17.7063'
        stroke='#2481C4'
      />
    </svg>
  );
};

Sharing.displayName = 'Sharing';

export default Sharing;
